import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import './style.scss';

export default class QuantitySkeleton extends Component {
  render() {
    return <Skeleton className={'quantity'} />;
  }
}
